module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'scheduler',
        'controller',
    ],
}